/**
 * Creates a URL-friendly slug from a given string.
 * Converts to lowercase, removes special characters, and replaces spaces with hyphens.
 *
 * @param text - The string to convert to a slug
 * @returns A URL-friendly slug
 *
 * @example
 * createSlug("COAM Laws, Rules, & Regulations") // "coam-laws-rules-regulations"
 * createSlug("Georgia COAM Information") // "georgia-coam-information"
 */
export function createSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}
